var _path, _path2, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 50,
    viewBox: "0 0 393 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.762 49.9966H536V47.9033H340.762C337.702 47.9107 334.671 47.3139 331.844 46.1473C329.017 44.9807 326.45 43.2675 324.293 41.1069L294.9 11.8385C292.543 9.48247 289.74 7.61578 286.653 6.3467C283.566 5.07761 280.256 4.4314 276.916 4.44554H3.49042V6.53888H276.916C279.977 6.53047 283.008 7.12687 285.835 8.29351C288.663 9.46015 291.229 11.1738 293.386 13.3352L322.779 42.6001C325.135 44.9568 327.939 46.8242 331.026 48.0939C334.113 49.3636 337.422 50.0103 340.762 49.9966Z",
    fill: "url(#paint0_linear_164_14504)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50969 8.96384C1.57827 8.96384 0.0125484 7.40493 0.0125484 5.48192C0.0125484 3.55891 1.57827 2 3.50969 2C5.44112 2 7.00684 3.55891 7.00684 5.48192C7.00684 7.40493 5.44112 8.96384 3.50969 8.96384Z",
    fill: "url(#paint1_linear_164_14504)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 218.011,
    cy: 6,
    r: 6,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.011,
    cy: 6,
    r: 6,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.011,
    cy: 6,
    r: 6,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_14504",
    x1: 168.74,
    y1: 27.2141,
    x2: 602.407,
    y2: 27.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_14504",
    x1: -7323.43,
    y1: 71.4994,
    x2: 1332.56,
    y2: 71.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR5);
export default __webpack_public_path__ + "static/media/r5.71c9f4a413a39e5a5632fcb10ab93d3f.svg";
export { ForwardRef as ReactComponent };